import { CommonModule } from '@angular/common'
import { NgModule } from '@angular/core'
import { FlexLayoutModule } from '@angular/flex-layout'
import { FormsModule, ReactiveFormsModule } from '@angular/forms'
import { MatAutocompleteModule } from '@angular/material/autocomplete'
import { MatButtonModule } from '@angular/material/button'
import { MatButtonToggleModule } from '@angular/material/button-toggle'
import { MatCardModule } from '@angular/material/card'
import { MatCheckboxModule } from '@angular/material/checkbox'
import { MatDialogModule } from '@angular/material/dialog'
import { MatDividerModule } from '@angular/material/divider'
import { MatExpansionModule } from '@angular/material/expansion'
import { MatFormFieldModule } from '@angular/material/form-field'
import { MatIconModule } from '@angular/material/icon'
import { MatInputModule } from '@angular/material/input'
import { MatListModule } from '@angular/material/list'
import { MatMenuModule } from '@angular/material/menu'
import { MatProgressBarModule } from '@angular/material/progress-bar'
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner'
import { MatRadioModule } from '@angular/material/radio'
import { MatSelectModule } from '@angular/material/select'
import { MatSliderModule } from '@angular/material/slider'
import { MatTooltipModule } from '@angular/material/tooltip'
import { MaskitoModule } from '@maskito/angular'
import { PipesModule } from '@mmx/pipes'
import { TranslateModule } from '@ngx-translate/core'

import { AddressFieldModule } from '../address-field'
import { AppLoaderModule } from '../app-loader'
import { BreadcrumbModule } from '../breadcrumb'
import { DateFieldModule } from '../date-selector'
import { PhoneFieldModule } from '../phone-field'
import { ProceduresCardModule } from '../procedures-card'
import { ProgressButtonModule } from '../progress-button'
import { BodyQuestionComponent } from './components/body-question/body-question.component'
import { CanvasComponent } from './components/canvas/canvas.component'
import { FileUploadComponent } from './components/file-upload/file-upload.component'
import { IfQuestionsComponent } from './components/if-questions/if-questions.component'
import { QuestionComponent } from './components/question/question.component'
import { TableComponent } from './components/table/table.component'
import { ConsentTermsDialogComponent } from './dialogs/consent-terms/consentTerms.dialog.component'
import { OverrideIntakeComponent } from './dialogs/override-intake/override-intake.component'
import { TermsDialogComponent } from './dialogs/terms-dialog/terms-dialog.component'
import { ConsentsComponent } from './partials/consents/consents.component'
import { CustomSectionComponent } from './partials/custom-section/custom-section.component'
import { TimelineComponent } from './partials/timeline/timeline.component'
import { PatientIntakeComponent } from './patient-intake.component'

const dialogs = [
  ConsentTermsDialogComponent,
  TermsDialogComponent,
  OverrideIntakeComponent,
]

@NgModule({
  declarations: [
    BodyQuestionComponent,
    CanvasComponent,
    ConsentsComponent,
    CustomSectionComponent,
    FileUploadComponent,
    IfQuestionsComponent,
    PatientIntakeComponent,
    QuestionComponent,
    TableComponent,
    TimelineComponent,
    ...dialogs,
  ],
  imports: [
    AddressFieldModule,
    AppLoaderModule,
    BreadcrumbModule,
    CommonModule,
    DateFieldModule,
    FlexLayoutModule,
    FormsModule,
    MaskitoModule,
    MatAutocompleteModule,
    MatButtonModule,
    MatButtonToggleModule,
    MatCardModule,
    MatCheckboxModule,
    MatDialogModule,
    MatDividerModule,
    MatExpansionModule,
    MatFormFieldModule,
    MatIconModule,
    MatInputModule,
    MatListModule,
    MatMenuModule,
    MatProgressBarModule,
    MatProgressSpinnerModule,
    MatRadioModule,
    MatSelectModule,
    MatSliderModule,
    MatTooltipModule,
    PhoneFieldModule,
    PipesModule,
    ProceduresCardModule,
    ProgressButtonModule,
    ReactiveFormsModule,
    TranslateModule,
  ],
  exports: [PatientIntakeComponent],
})
export class PatientIntakeModule {}
